import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import TypeTextEditor from "../../form/TypeTextEditor";
import UrlField from "../../form/UrlField";
import Select from "../../form/Select";
import PriorityField from "../../form/PriorityField";

class seriesForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-10">
                        <TextInput name="title" value={this.props.values.title} label="Megnevezés" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("title")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TypeTextEditor name="description" label="Leírás" data={this.props.values} componentConfig={this.props.componentConfig} getFieldProps={this.props.getFieldProps} setFieldValue={this.props.setFieldValue}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            name="parent"
                            component={this.props.componentConfig.fielddefs.parent.object}
                            objectValue={true}
                            labelKey="title"
                            storeType="remote"
                            label="Szülő"
                            value={this.props.values.parent}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("parent")}
                        />
                    </div>
                </div>
                {this.props.componentConfig.fielddefs.url &&
                <UrlField {...this.props}/>}
                {this.props.componentConfig.fielddefs.priority &&
                <PriorityField {...this.props}/>}
            </form>
        );
    }
}

export default createForm(seriesForm);
